import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest
} from "redux-saga/effects";

import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
  userSignUpSuccess,
  showLoader,
  Types,
  hideAuthLoader,
  showAuthLoader,
  authForbidden
} from "../reducers/Auth";

import Auth from "../../services/Auth";

const uid = { user: { udi: "vUAqPRNWgYdS2DyJNAC1lV5KpJF2" } };

const sessionFields = [
  "permissions",
  "companyAccessMode",
  "companyIds",
  "channelAccessMode",
  "channelIds",
  "authorization"
];

const buildSession = response => {
  const user = response && response.user ? response.user : response;
  const session = { ...(user || {}) };

  sessionFields.forEach(field => {
    if (response && response[field] !== undefined && session[field] === undefined) {
      session[field] = response[field];
    }
  });

  if (!session.permissions) {
    session.permissions = [];
  }

  return session;
};

const getErrorMessage = error => error && error.message ? error.message : error;

const validateTokenRequest = () =>
  Auth.refresh()
    .then(status => status)
    .catch(err => {
      throw err;
    });

const signInUserWithUsernamePasswordRequest = (login, password, authBy) =>
  Auth.login(login, password, authBy)
    .then(user => user)
    .catch(err => {
      throw err;
    });
  
const validateExternalTokenRequest = token =>
  Auth.validateExternalToken(token)
    .then(user => user)
    .catch(err => {
      throw err;
    });

function* createUserWithUsernamePassword({ payload }) {
  try {
    const signUpUser = yield uid;
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user", signUpUser.user.uid);
      yield put(userSignUpSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithUsernamePassword({ payload }) {
  try {
    const authBy = { Company: "solutis", LDAP: true };
    const response = yield call(
      signInUserWithUsernamePasswordRequest,
      payload.username,
      payload.password,
      authBy
    );

    if (response) {
      localStorage.setItem("token", JSON.stringify(response.token));

      yield put(userSignInSuccess(buildSession(response)));
    } else {
      yield put(showAuthMessage("Usuário não encontrado."));
    }
  } catch (error) {
    yield put(showAuthMessage(getErrorMessage(error)));
  }
}

function* signOut() {
  try {
    localStorage.removeItem("token");
    yield put(userSignOutSuccess());
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* validateToken() {
  try {
    yield put(showLoader(true));
    const response = yield call(validateTokenRequest);

    yield put(userSignInSuccess(buildSession(response)));
  } catch (error) {
    const status = error && (error.status || (error.response && error.response.status));
    if (status === 403) {
      yield put(authForbidden());
      yield put(showAuthMessage("Sem permissão para acessar este recurso."));
    } else {
      localStorage.removeItem("token");
      yield put(userSignOutSuccess());
      yield put(showAuthMessage(getErrorMessage(error)));
    }
  }
}

function* validateExternalToken({ payload }) {
  try {
    yield put(showAuthLoader());
    const response = yield call(validateExternalTokenRequest, payload);
    if (response) {
      localStorage.setItem("token", JSON.stringify(payload));

      yield put(userSignInSuccess(buildSession(response)));
      yield put(hideAuthLoader())
    } else {
      yield put(showAuthMessage("Usuário não encontrado."));
    }
  } catch (error) {
    yield put(showAuthMessage(getErrorMessage(error)));
  }
}

export function* createUserAccount() {
  yield takeEvery(Types.SIGNUP_USER, createUserWithUsernamePassword);
}

export function* signInUser() {
  yield takeEvery(Types.SIGNIN_USER, signInUserWithUsernamePassword);
}

export function* signOutUser() {
  yield takeEvery(Types.SIGNOUT_USER, signOut);
}
export function* validateUserToken() {
  yield takeLatest(Types.VALIDATE_TOKEN, validateToken);
}

export function* validateUserExternalToken() {
  yield takeLatest(Types.VALIDATE_EXTERNAL_TOKEN, validateExternalToken);
}

export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(createUserAccount),
    fork(validateUserToken),
    fork(signOutUser),
    fork(validateUserExternalToken)
  ]);
}
